import { render, staticRenderFns } from "./AdminWithdrawals.vue?vue&type=template&id=8e9c27ac&scoped=true"
import script from "./AdminWithdrawals.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawals.vue?vue&type=script&lang=js"
import style0 from "./AdminWithdrawals.vue?vue&type=style&index=0&id=8e9c27ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9c27ac",
  null
  
)

export default component.exports